import { oidcEarlyInit } from "oidc-spa/entrypoint";



const { shouldLoadApp } = oidcEarlyInit({
BASE_URL: "./",

securityDefenses: {



}
});

if (shouldLoadApp) {
import("./index.tsx?oidc-spa-original=true");
}